import React, {Component} from 'react'

import lockIcon from "manager/../images/lock.svg"
import clipboardIcon from "manager/../images/clipboard_icon.svg"
import styled from "styled-components"
import {
  DESKTOP_BREAKPOINT
} from "manager/views/components/Settlement/constants"
import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import {
  selectAgentOpId,
  selectSelectedProviderIsQualiaSupported, selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"
import {segmentEventTracker} from "common/analytics"
import {
  SettlementButton,
  TextButtonContainer,
  TextContainer
} from "manager/views/components/Settlement/Common/TextButton"

const OpenNewOrderContainer = styled(SettlementCard)`
  display: flex;
  flex-direction: row;
`
const Icon = styled.div`
  margin-top: 30px;
  margin-right: 10px;

  color: #BBBBBB;
  flex: 0 0 16px;
  background-size: cover;
`
const LockIcon = styled(Icon)`
  background-image: url(${lockIcon});
  height: 18px;
  width: 16px;
`
const ClipboardIcon = styled(Icon)`
  background-image: url(${clipboardIcon});
  height: 22px;
`
const HeaderDiv = styled.div`
  color: ${props => props.isQualia === true ? '#545454' : '#B4B3B3'}
  font-size: 20px;
  font-weight: bold;
`
const TextDiv = styled.div`
  color: ${props => props.isQualia ? '#4A4A4A' : '#B4B3B3'}
  margin: 12px 0px 20px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    width: 368px;
  }
`

class OpenNewOrder extends Component {
  componentDidMount() {
    if (this.props.isQualiaSupported){
      segmentEventTracker("New-Order Viewed", {'transaction_op_id': this.props.transaction_op_id, 'agent_op_id': this.props.agent_op_id})
    }
  }

  render() {
    const {isQualiaSupported, setPlaceOrderView} = this.props
    return (
      <OpenNewOrderContainer paddingLeft='35px' paddingRight='60px'>
        { isQualiaSupported ? <ClipboardIcon/> : <LockIcon/>}
        <TextButtonContainer>
          <TextContainer>
            <HeaderDiv isQualia={isQualiaSupported}>Open a New Order</HeaderDiv>
            <TextDiv isQualia={isQualiaSupported}>
              {isQualiaSupported
                ? "When ready, place a title order here in just a few seconds and we'll automate your status updates towards close."
                : "This provider doesn't integrate with our digital close experience. If you're looking for real-time progress tracking, automated tasks, and secure document sharing, you can remove this one and search for a Qualia-enabled provider."
              }
            </TextDiv>
          </TextContainer>
          <SettlementButton disabled={!isQualiaSupported} primary oldColorPalette={true} largerFont={true}
                            paddingTopBottom={10} paddingLeftRight={22.5} onClick={setPlaceOrderView}>Place order</SettlementButton>
        </TextButtonContainer>
      </OpenNewOrderContainer>
    )
  }
}

const selector = createStructuredSelector({
  isQualiaSupported: selectSelectedProviderIsQualiaSupported,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(OpenNewOrder)
